import { LocalStoragePlayerApi } from './localStoragePlayersApi';
import { LocalStoragePlayersPresetsApi } from './localStoragePlayersPresetsApi';

export * from './players';
export * from './presets';

export const playersApi = new LocalStoragePlayerApi(window.localStorage);
export const playersPresetsApi = new LocalStoragePlayersPresetsApi(
  window.localStorage
);
